import { useContext } from "react";
import { useQuery } from "react-query";
import AppContext from "../appContext";
import * as api from "../services";

export default function usePublicInteraction(interactionId) {
  const {
    app: {
      pauseQueries,
      project: { id: projectId },
      sessionId,
    },
  } = useContext(AppContext);
  const { data, isLoading, refetch } = useQuery(
    ["survey", [interactionId, projectId, sessionId]],
    () => api.getPublicInteraction({ interactionId, projectId, sessionId }),
    {
      enabled: !isNaN(interactionId) && interactionId !== 0 && !pauseQueries,
    }
  );
  return {
    publicInteraction: data,
    isPublicInteractionLoading: isLoading,
    refetchPublicInteraction: refetch,
  };
}
